/* istanbul ignore file */ /* this file is not used or will be deleted in other branches */
// @ts-nocheck
import React, { useEffect } from 'react';
import useFieldApi from '@data-driven-forms/react-form-renderer/dist/cjs/use-field-api';
import clsx from 'clsx';
import { customComponentTypes } from '../ddf/component-mapper';

export function CheckboxGrid({ name, isChecked, initialValue }) {
  const { input } = useFieldApi({
    name,
    type: 'checkbox',
    component: customComponentTypes.CHECKBOX_GRID,
    initialValue
  });

  useEffect(() => {
    input.onChange(isChecked);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isChecked]);

  return (
    <div className="h-12 flex items-center space-x-3 px-2">
      <label className="flex justify-start items-start">
        <div className="field-with-icons rounded w-5 h-5 flex flex-shrink-0 justify-center items-center">
          <input type="checkbox" className="opacity-0 absolute" {...input} />
          <svg
            viewBox="0 0 20 20"
            className={clsx('fill-current w-3 h-3 text-primary-500 pointer-events-none', !input.checked && 'hidden')}
          >
            <path d="M0 11l2-2 5 5L18 3l2 2L7 18z" />
          </svg>
        </div>
      </label>
    </div>
  );
}
